import { useCallback } from 'react';
import { getOnboardingRouteRedirect, shouldRenderOnboardingChildren } from 'utils/authNavigation';
import { useAuthSession } from 'hooks/useAuthSession';
import { useAuthRedirect } from 'hooks/useAuthRedirect';

/**
 * Routes that require a partial session (2FA setup or password update).
 * @param {'setup2fa' | 'updatePassword'} flow
 */
export default function OnboardingAuthRoute({ flow, children }) {
  const session = useAuthSession();
  const resolveRedirect = useCallback((s) => getOnboardingRouteRedirect(s, flow), [flow]);

  useAuthRedirect(resolveRedirect);

  if (!shouldRenderOnboardingChildren(session, flow)) {
    return null;
  }

  return children;
}
